import UtilityHelper from '../utility-helper/utility-helper';
export default class StateSelectElement extends HTMLElement {
  constructor() {
    super();
  }

  static get observedAttributes() {
    return ['value', 'readonly', 'disabled'];
  }

  connectedCallback() {
    this.fire = UtilityHelper.fireEvent;

    this._attachToDom();

    this._setDefaultValue();

    this._setEvents();
  }

  disconnectedCallback() {
    this._removeEvents();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (this.select && oldValue) {
      this.select.setAttribute(name, newValue);

      if ((name === 'readonly' || name === 'disabled') && (newValue === 'false' || newValue === false)) {
        this.select.removeAttribute(name);
      }
    }
  }

  _attachToDom() {
    var dom = '';
    var requiredAttribute = '';
    var disabledAttribute = '';

    if (this.defaultRequired) {
      requiredAttribute = ' required';
    }

    if (this.defaultDisabled) {
      disabledAttribute = ' disabled';
    }

    dom += '<select id="' + this.defaultId + '" name="' + this.defaultName + '"' + requiredAttribute + disabledAttribute + '>';
    dom += this._getOptions();
    dom += '</select>';
    var $dom = $(dom);
    $(this).append($dom);
    this.select = this.querySelector('select');
  }

  _setEvents() {
    var onChange = this._onChange.bind(this);

    var select = this.select;
    select.addEventListener('change', onChange);
  }

  _removeEvents() {
    var onChange = this._onChange.bind(this);

    var select = this.select;
    select.removeEventListener('change', onChange);
  }

  _getOptions() {
    var options = '<option value="Select">Select State</option><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District Of Columbia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvania</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option><option value="AS">American Samoa</option><option value="GU">Guam</option><option value="MP">Northern Mariana Islands</option><option value="PR">Puerto Rico</option><option value="UM">United States Minor Outlying Islands</option><option value="VI">Virgin Islands</option>';
    return options;
  }

  _onChange(event) {
    this.fire('state-select-change', {
      value: event.target.value,
      target: this,
      id: this.id,
      name: this.name
    });
  }

  _setDefaultValue() {
    if (this.defaultValue) {
      this.select.value = this.defaultValue;
    }
  }

  get value() {
    return this.select.value;
  }

  set value(val) {
    this.select.value = val;
  }

  get id() {
    return this.select.getAttribute('id');
  }

  get name() {
    return this.select.getAttribute('name');
  }

  get defaultId() {
    var id = this.dataset.id;
    if (!id) return 'state';else return id;
  }

  get defaultName() {
    var name = this.dataset.name;
    if (!name) return 'state';else return name;
  }

  get defaultValue() {
    return this.dataset.value;
  }

  get defaultRequired() {
    return this.dataset.required;
  }

  get defaultDisabled() {
    return this.dataset.disabled;
  }

  clear() {
    this.select.value = '';
  }

}
customElements.define('state-select', StateSelectElement);